import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../Footer/Footer";
import NavBar from "../NavBar/NavBar";
import useSiteMetadata from "../SiteMetadata";
import { withPrefix } from "gatsby";

import styles from "./Layout.module.scss";

const TemplateWrapper = ({ children }) => {
  const { title, description } = useSiteMetadata();
  return (
    <div>
      <Helmet>
        <html lang="el" />
        <title>{title}</title>
        <meta name="description" content={description} />

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${withPrefix("/")}img/apple-touch-icon.png`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-32x32.png`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-16x16.png`}
          sizes="16x16"
        />
        <meta name="theme-color" content="#ffffff" />

        <meta property="og:type" content="business.business" />
        <meta property="og:title" content={title} />
        <meta property="og:url" content="/" />
        <meta property="og:image" content={`${withPrefix("/")}img/home.png`} />
      </Helmet>
      <NavBar />
      <div className={styles.main}>{children}</div>
      <Footer />
    </div>
  );
};

export default TemplateWrapper;
